var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcPin(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 13,
    viewBox: "0 0 10 13",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5 0.5C2.49219 0.5 0.5 2.53906 0.5 5C0.5 6.6875 1.03906 7.20312 4.03906 11.9844C4.48438 12.6875 5.49219 12.6875 5.9375 11.9844C8.9375 7.20312 9.5 6.6875 9.5 5C9.5 2.51562 7.46094 0.5 5 0.5ZM5 11.375C2 6.59375 1.625 6.28906 1.625 5C1.625 3.14844 3.125 1.625 5 1.625C6.85156 1.625 8.375 3.14844 8.375 5C8.375 6.28906 8 6.54688 5 11.375ZM3.125 5C3.125 6.05469 3.94531 6.875 5 6.875C6.03125 6.875 6.875 6.05469 6.875 5C6.875 3.96875 6.03125 3.125 5 3.125C3.94531 3.125 3.125 3.96875 3.125 5Z",
    fill: "#199690"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcPin);
export default __webpack_public_path__ + "static/media/ic-pin.2d7074f45c892da019c8058618c458f1.svg";
export { ForwardRef as ReactComponent };